import { useMutation } from '@tanstack/react-query';

import { createTeamInvite } from '../../../api/teams';

export function useCreateTeamInvite() {
  return useMutation({ mutationFn: createTeamInvite });
}
